$(document).ready(function () {
    $('.table-projects select').on('change', function () {
        // Ignore search select on change
        if ($(this).hasClass('search-select')) {
            return;
        }

        var projectId = $(this).data('project-id');

        var projectTypeStatusId = $("option:selected", this).data('project-type-status-id');
        var action = $("option:selected", this).data('action');
        var actionTitle = $("option:selected", this).data('action-title');

        var actionRoute = "/admin/projects/"+projectId+'/'+action+'/'+projectTypeStatusId;

        if (action !== undefined && action != '') {
            window.sidePanels.open($('#data-side-panel-project-type-status-action'), actionRoute);
            window.sidePanels.getCurrentSidePanel().find('.card-header').find('div:first').html(actionTitle);
        }

        var statusId = $(this).val();

        var customerIcon = $(this).closest('tr').find('.customer-icon');
        var statusCell = $(this).closest('td');
        var statusColor = $("option:selected", this).data('color');
        let statusTextColor = $("option:selected", this).data('text-color');

        customerIcon.html('<i class="fas fa-spinner fa-spin"></i>');

        $.get("/admin/projects/"+projectId+'/set-status/'+statusId, function () {
            customerIcon.html('<i class="fas fa-check text-success"></i>');
            setTimeout(function() {
                customerIcon.html('');
                statusCell.css( "background-color", statusColor);
                statusCell.find( "button" ).css( "background-color", statusColor );
                statusCell.find( "select" ).css( "background-color", (statusColor !== '#ffffff' ? statusColor  : "#f7f7f9") );
                statusCell.find( "select" ).css( "color",statusTextColor);
                statusCell.find( ".planned-at-text" ).css( "color",statusTextColor);
            }, 800);
        })
            .fail(function () {
                customerIcon.html('<i class="fas fa-exclamation-triangle text-danger"></i>');
            });
    });


    if (sessionStorage.getItem('scrollPosition') && sessionStorage.getItem('scrollPositionHorizontal')) {
        // get scroll position from session
        var scrollPosition = sessionStorage.getItem('scrollPosition');
        var scrollPositionHorizontal = sessionStorage.getItem('scrollPositionHorizontal');

        // scroll to it if it exists
        $('.table-responsive')[0].scrollTop = scrollPosition;
        $('.table-responsive')[0].scrollLeft = scrollPositionHorizontal;

        // remove scroll position from session
        sessionStorage.removeItem('scrollPosition');
        sessionStorage.removeItem('scrollPositionHorizontal');
    }
});


$(document).on('click', '.table-projects tbody tr td:not(:first-child)', function (e) {
    // save scroll position in table
    sessionStorage.setItem('scrollPosition', $('.table-responsive')[0].scrollTop);
    // save horizontal scroll position in table
    sessionStorage.setItem('scrollPositionHorizontal', $('.table-responsive')[0].scrollLeft);
});
